

import { FC, useContext, useMemo } from 'react';

import TrialsContext from '@/contexts/data/TrialsContext';
import useGetTrials from '@/hooks/data/useGetTrials';
import IHasChildren from '@/types/components/IHasChildren';
import Loading from '@/components/layout/Loading';
import AuthContext from '@/contexts/auth/AuthContext';


interface ITrialsProviderProps extends IHasChildren { }

const TrialsProvider: FC<ITrialsProviderProps> = ({
    children
}) => {
    const { data } = useContext(AuthContext);

    const trialsQuery = useGetTrials(data ? {} : undefined, {});
    
    const context = useMemo(() => {
        return trialsQuery;
    }, [trialsQuery]);

    return (
        <>
            <Loading name='trials-provider' isLoading={trialsQuery.loading} isValidating={trialsQuery.validating}/>
            <TrialsContext.Provider value={context}>
                {children}
            </TrialsContext.Provider>
        </>
    )
}

export default TrialsProvider